import { render, staticRenderFns } from "./slot-price-category-table.vue?vue&type=template&id=6e3f6b2e&scoped=true&"
import script from "./slot-price-category-table.ts?vue&type=script&lang=ts&"
export * from "./slot-price-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./slot-price-category-table.scss?vue&type=style&index=0&id=6e3f6b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3f6b2e",
  null
  
)

export default component.exports